/****************************************************
 * Module Name:  lotintimationProxy.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/

import restAPICall from "../../../api/restAPICall";
import Constants from "../../../constants";

export default class LotIntimationProxy {
  static GetAllLotIntimation = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/lotintimation",
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetSingleLotIntimation = (lotintimationId, callback) => {
    let params = {
      id: lotintimationId,
    };

    restAPICall(
      Constants.MANAGER_URL + `/lotintimation`,
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetLotDocumentsById = (lotintimationId, callback) => {
    let params = {
      id: lotintimationId,
    };

    restAPICall(
      Constants.MANAGER_URL + `/lotdocument`,
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static UploadDocument = (intimationid, data, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/lotdocument/${intimationid}`,
      "post",
      Constants.userToken,
      undefined,
      data,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static CheckLotIntimationAvailable = (lotintimation, callback) => {
    let params = {
      lotid: lotintimation,
    };

    restAPICall(
      Constants.MANAGER_URL + "/lotintimation/available",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static AddLotIntimation = (lotintimation, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/lotintimation",
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(lotintimation),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static UpdateLotIntimation = (lotintimation, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/lotintimation",
      "put",
      Constants.userToken,
      undefined,
      JSON.stringify(lotintimation),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static DeleteLotIntimation = (lotintimation, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/lotintimation",
      "delete",
      Constants.userToken,
      undefined,
      JSON.stringify(lotintimation),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static LotIntimationPendingReceive = (data, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/lotintimation/pendingreceive",
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(data),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };
}
